import { render, staticRenderFns } from "./tproductfileconfig.vue?vue&type=template&id=caa1ad7a&"
import script from "./tproductfileconfig.vue?vue&type=script&lang=js&"
export * from "./tproductfileconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports